module.exports = __webpack_public_path__ + "img/rpg_3.a0cf8156.jpeg";